import React, { useState, useMemo, useEffect } from 'react';
import './BasketNamingSheet.css';

function BasketNamingSheet({ isOpen, onSave, onSkip, basketItems }) {
  const [name, setName] = useState('');

  // Reset each time the sheet opens
  useEffect(() => {
    if (isOpen) setName('');
  }, [isOpen]);

  // Smart suggestions based on basket size
  const suggestions = useMemo(() => {
    const count = basketItems?.length || 0;
    if (count >= 15) return ['Big shop', 'Weekly shop', 'Full shop', 'Essentials'];
    if (count >= 5)  return ['Weekly shop', 'Top-up shop', 'My usual shop', 'Essentials'];
    return ['Top-up shop', 'Quick shop', 'Essentials', 'Milk run'];
  }, [basketItems]);

  const finalName = name.trim() || 'My list';

  if (!isOpen) return null;

  return (
    <>
      <div className="sheet-backdrop" onClick={onSkip} />
      <div className="naming-sheet">
        <div className="sheet-handle" />
        <h2 className="naming-sheet-title">Name this list</h2>
        <p className="naming-sheet-sub">Optional — you can change this later</p>

        <input
          className="naming-input"
          type="text"
          placeholder="e.g. Weekly shop"
          value={name}
          onChange={e => setName(e.target.value)}
          maxLength={40}
          autoFocus
        />

        <div className="naming-chips">
          {suggestions.map(s => (
            <button
              key={s}
              className={`naming-chip${name === s ? ' active' : ''}`}
              onClick={() => setName(name === s ? '' : s)}
            >{s}</button>
          ))}
        </div>

        <button className="naming-save-btn" onClick={() => onSave(finalName)}>
          Save list
        </button>
        <button className="naming-skip-btn" onClick={onSkip}>
          Skip
        </button>
      </div>
    </>
  );
}

export default BasketNamingSheet;
